import { render, staticRenderFns } from "./V6IndikasiTercatatGanda.vue?vue&type=template&id=4ffa7c85&"
import script from "./V6IndikasiTercatatGanda.vue?vue&type=script&lang=js&"
export * from "./V6IndikasiTercatatGanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports